import * as yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const lockCodeSchema = yup.object().shape({
  code: yup.string().min(4).required().matches(/^\d+$/, 'code must be a number'),
  name: yup.string().required(),
});
